import { Component, OnInit, Input, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
declare var $;

@Component({
  selector: 'kms-tree-multi-box',
  templateUrl: './kms-tree-multi-box.component.html',
  styleUrls: ['./kms-tree-multi-box.component.css']
})
export class KmsTreeMultiBoxComponent implements OnInit {

  constructor(private el: ElementRef,
    private box: SwMassageBoxService,
    private kmsService: KmsService,) { }

  ngOnInit() {
  }

  @Input() ids: any;

  @Input() elem: any;

  @Input() dropdown: boolean = true;;

  @Input() height: string = '250px';

  @Input() datas: any = []

  /**
   * 最多能选择的个数
   */
  @Input() maxSelectNum: number = 0;

  /**
   * 最多能选择的个数
   */
  @Input() createNewData: boolean = false;

  /**
   * 是否有搜索框
   */
  @Input() isSearch: boolean = false;

  /**
   * 是否允许新增
   */
  @Input() addEnable: boolean = false;

  /**
   * 不允许选择的节点id
   */
  @Input() readonlySelfIds: any = [];

  /**
   * 同步默认打开到第几节点
   */
  @Input() openNode: number;

  /**
   * 是否通过所属概念组添加关系
   */
  @Input() conceptGroup: any = {
    sourceConceptId: '',
    sourceConceptName: '',
    targetConceptId:'',
    targetConceptName:''
  };
  /**
   * 是否有搜索结果
   */
  hasRes = true;

  /**
 * 选中的id
 * @ignore
 */
  @Input() selected: any = [];
  selectedIds:any = [];

  /**
   * 选中的文本
   * @ignore
   */
  @Input() selectedText = [];

  /**
   * 搜索框的值
   */
  filter: any;

  // 下拉框是否可关闭
  closeState = true;

  /**
   * 选中数据
   */
  @Output() changeClick = new EventEmitter();
  @Output() closeSelect = new EventEmitter();

  ngAfterViewInit(): void {
    //如果有搜索框则给焦点
    let postion = this.elem.nativeElement.getBoundingClientRect()
    this.el.nativeElement.style.position = 'fixed';
    this.el.nativeElement.style.zIndex = 9990;
    //this.el.nativeElement.style.top = postion.bottom + 'px';
    this.el.nativeElement.style.left = postion.left + 'px';
    this.el.nativeElement.style.width = postion.width + 'px';
    this.selectedIds = this.selected;
    let height = this.height.split('px')[0]
    let clientHeight = document.documentElement.clientHeight || document.body.clientHeight
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    let heightAndTop = clientHeight + scrollTop
    if ((heightAndTop - postion.bottom) < parseInt(height)) {
      this.el.nativeElement.style.top = postion.bottom - parseInt(height) + 15 + 'px';
    } else {
      this.el.nativeElement.style.top = postion.bottom + 'px';
    }
    //如果有搜索框则给焦点
    if (this.isSearch == true) {
      setTimeout(() => {
        // 获取input的dom元素
        var search = document.getElementById(this.ids);
        if (search) {
          // 自动获取焦点
          search.focus()
        }
      }, 200)
    }

    this.myModalBodyScroll()  //监听 myModalBody 盒子的滚动条事件
    this.myWrapContScroll()  //监听 myWrapCont 盒子的滚动条事件
  }

  ngOnDestroy(): void {
    this.myModalBodyRmScroll()  //移除 myModalBody 盒子的滚动条事件
    this.myWrapContRmScroll()  //移除 myWrapCont 盒子的滚动条事件
  }

  /**
 * 判断是否选中数据
 * @param id  选中的id
 * @ignore
 */
  isChecked(id) {
    return this.selected.findIndex(value => value == id) >= 0;
  }

  /**
   * 判断点击的数据是新增还是删除 ，做出相对的处理
   * @param action  添加还是删除
   * @param item  选中的数据
   * @ignore
   */
  private updateSelected(action, item) {

    // 新增添加点击的数据
    if (action == 'add' && this.selected.findIndex(value => value == item.id) == -1) {
      //如果有选中标签个数限制，那么在新增的时候，超过个数就不能新增了
      if (this.maxSelectNum && this.selected.length >= this.maxSelectNum) {
        this.box.danger('已达到最大选中数')
        return
      }
      this.selected.push(item.id);
      this.selectedText.push(item.text);
    }
    // 替换之前选择的数据
    if (action == 'replace') {
      //如果有选中标签个数限制，那么在新增的时候，超过个数就不能新增了
      if (this.maxSelectNum && this.selected.length >= this.maxSelectNum) {
        this.box.danger('已达到最大选中数')
        return
      }
      if(item.length>0){
        this.selected = [];
        this.selectedText = [];
        item.forEach(child => {
          this.selected.push(child.id);
          this.selectedText.push(child.text);
        })
      }else{
        this.selected = [];
        this.selectedText = [];
      }
    }
    // 删除 就删除对应的数据
    if (action == "remove" && this.selected.findIndex(value => value == item.id) != -1) {
      this.selectedText.splice(this.selected.findIndex(value => value == item.id), 1);
      this.selected.splice(this.selected.findIndex(value => value == item.id), 1);
    }
    let param = { "action": action, "item": item }
    this.changeClick.emit(param);
  }

  // 关闭下拉框
  close() {
    this.closeSelect.emit(false)
  }

  @HostListener('document:mousewheel', ['$event']) onmousewheel(event) {
    //鉴定全屏键盘事件 如果是回车触发
    if (this.mouseo)
      this.closeSelect.emit(false)
  }

  // //屏幕缩放时
  // @HostListener('window:resize', ['$event']) resize(event) {
  //   /* //屏幕缩放时,下拉框消失,否则下拉框
  //   this.closeSelect.emit(false) */
  //   //屏幕缩放时,重新设置下拉框的位置及宽度
  //   let postion = this.elem.nativeElement.getBoundingClientRect()
  //   this.el.nativeElement.style.top = postion.bottom + 'px';
  //   this.el.nativeElement.style.left = postion.left + 'px';
  //   this.el.nativeElement.style.width = postion.width + 'px';
  // }

  mouseo: boolean = true;
  mouseoverEvent() {
    this.mouseo = false;
  }
  mouseoutEvent() {
    this.mouseo = true;
  }

  //监听 myWrapCont 盒子的滚动条事件,滚动就让日期控件消失
  myWrapContScroll() {
    let _scroll = $("#myWrapCont")[0]
    if (_scroll) {
      _scroll.addEventListener('scroll', () => {
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myWrapContRmScroll() {
    let _scroll = $("#myWrapCont")[0]
    if (_scroll) {
      _scroll.removeEventListener('scroll', this.myWrapContScroll)
    }
  }

  //监听 myModalBody 盒子的滚动条事件,滚动就让日期控件消失
  myModalBodyScroll() {
    let _scroll = $("#myModalBody")[0]
    if (_scroll) {
      _scroll.addEventListener('scroll', () => {
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myModalBodyRmScroll() {
    let _scroll = $("#myModalBody")[0]
    if (_scroll) {
      _scroll.removeEventListener('scroll', this.myModalBodyScroll)
    }
  }

  /**
   * 失去焦点
   * @ignore
   */
  Blur() {
    setTimeout(() => {
      if(this.closeState){
        // 销毁组件
        this.closeSelect.emit(false);
      }else{
        // 获取input的dom元素
        var search = document.getElementById(this.ids);
        if (search) {
          // 自动获取焦点
          search.focus()
        }
      }
    }, 200);
    event.stopImmediatePropagation();
  }

  /**
   * 下拉框选中事件
   * @ignore
   */
  handleVotedClick(event) {
    if(event.length > 0){
      event.forEach(item => {
        item['id'] = item['key'];
        item['text'] = item['title'];
      })
    }
    console.log(this.datas)
    this.updateSelected('replace', event);
    this.closeState = false;
    setTimeout(()=>{
      this.closeState = true;
    },500);
    return false; //阻止事件冒泡而关闭下拉框
  }

  // 搜索框内容发生变化
  isHasRes(event){
    let keyword = $.trim(this.filter);
    if(!keyword){
      this.hasRes = true;
      return;
    }
    var newlist= this.datas.filter(x=>x.text.indexOf(keyword)>=0);
    this.hasRes = newlist.length > 0;
  }

  // 添加关系节点
  add(){
    // if(this.conceptGroup.sourceConceptId && this.conceptGroup.targetConceptId){
    //   let text = this.conceptGroup.sourceConceptName + '-' + this.conceptGroup.targetConceptName;
    //   let arr = this.datas.filter(item => item.text == text);
    //   if(arr.length > 0){
    //     this.conceptGroup.conceptRelationshipId = arr[0].id;
    //   }
    //   // 保存关系信息
    //   let params = {
    //     "conceptRelationshipId": this.conceptGroup.conceptRelationshipId,
    //     "sourceConceptId": this.conceptGroup.sourceConceptId,
    //     "sourceConceptName": this.conceptGroup.sourceConceptName,
    //     "targetConceptId": this.conceptGroup.targetConceptId,
    //     "targetConceptName": this.conceptGroup.targetConceptName,
    //     "relationship": {
    //         "conceptRelationshipId": this.conceptGroup.conceptRelationshipId,
    //         "relationName": $.trim(this.filter),
    //         "relationLevel": 1,
    //         "parentId": this.conceptGroup.conceptRelationshipId
    //     }
    //   }
    //   this.kmsService.saveConceptRelationUpdate(params).subscribe(
    //       data => {
    //           if(data.code == '200'){
    //             this.box.success('添加成功!');
    //             // let item = {
    //             //   'id': data.data.relationship.relationshipId,
    //             //   'text': data.data.relationship.relationName
    //             // }
    //             // this.dropdown = false;//关闭下拉框
    //             // this.closeSelect.emit(item)
    //           }else{
    //             this.box.waring(data.msg);
    //           }
    //       }
    //   )
    // }else{
    //   this.box.danger('请选择起始和指向子概念！');
    // }
  }
}
